var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0ZM8 14.6429C4.33214 14.6429 1.35714 11.6679 1.35714 8C1.35714 4.33214 4.33214 1.35714 8 1.35714C11.6679 1.35714 14.6429 4.33214 14.6429 8C14.6429 11.6679 11.6679 14.6429 8 14.6429Z",
    fill: "#C62B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1198 10.2607L8.57335 8.41968V4.00003C8.57335 3.92146 8.50907 3.85718 8.4305 3.85718H7.57157C7.493 3.85718 7.42871 3.92146 7.42871 4.00003V8.91789C7.42871 8.96432 7.45014 9.00718 7.48764 9.03396L10.4412 11.1875C10.5055 11.234 10.5948 11.2197 10.6412 11.1572L11.1519 10.4607C11.1984 10.3947 11.1841 10.3054 11.1198 10.2607Z",
    fill: "#C62B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.c8eedfc8558dfef7bbbddf72782bc117.svg";
export { ForwardRef as ReactComponent };